import { render, staticRenderFns } from "./ReviewFooter.vue?vue&type=template&id=cd7c103e"
import script from "./ReviewFooter.vue?vue&type=script&lang=ts"
export * from "./ReviewFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports